class ContextError extends Error {
  context;
  constructor(message, context = {}) {
    super(message);
    this.name = "ContextError";
    this.context = context;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ContextError);
    }
  }
}
function hasErrorContext(error) {
  return error instanceof Error && "context" in error && typeof error.context === "object";
}
export {
  ContextError,
  hasErrorContext
};
//# sourceMappingURL=ContextError.js.map
